import styled from 'styled-components';

export const Container = styled.div`
    img {
        width: 80%;
        margin-left: 10%;
    }

    .code {
        font-weight: 600;
    }
`;

export const Title = styled.h1`
    font-style: normal;
    font-weight: 700;
    font-size: 28px;
    line-height: 48px;
`;
